import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { V2ButtonComponent, V2DialogFrameComponent, V2DialogFooterComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'admin-view-information-dialog',
  templateUrl: './view-information-dialog.component.html',
  styleUrls: ['./view-information-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [V2DialogFrameComponent, V2DialogFooterComponent, V2ButtonComponent, TranslatePipe]
})
export class ViewInformationDialogComponent {
  data = inject<{
    translationPrefix: string;
  }>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject<MatDialogRef<ViewInformationDialogComponent>>(MatDialogRef);

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
